export const ROOT_URL = process.env.NEXT_PUBLIC_URL;
export const ROOT_API_URL = process.env.NEXT_PUBLIC_API_URL;
export const API_SERVICE_TOKEN = process.env.NEXT_PUBLIC_API_SERVICE_TOKEN;
export const ROOT_AUTH_URL = process.env.NEXT_PUBLIC_AUTH_URL;
export const AUTH_MARKER = process.env.NEXT_PUBLIC_AUTH_MARKER;
export const ROOT_PRIORITY_URL = process.env.NEXT_PUBLIC_PRIORITY_URL;
